import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { RoleFilter } from "./RoleFilter";
import { SprintSelector } from "./SprintSelector";
import { TaskRole } from "@/components/scheduler/schedulerTypes";

interface FilterSidebarProps {
  selectedRole: TaskRole | 'all';
  setSelectedRole: (role: TaskRole | 'all') => void;
  selectedSprintId: string | 'all';
  setSelectedSprintId: (sprintId: string | 'all') => void;
  sidebarExpanded: boolean;
  setSidebarExpanded: (expanded: boolean) => void;
  boardId?: string | null;
  onCreateSprint: () => void;
}

export function FilterSidebar({ 
  selectedRole, 
  setSelectedRole,
  selectedSprintId,
  setSelectedSprintId,
  sidebarExpanded,
  setSidebarExpanded,
  boardId,
  onCreateSprint
}: FilterSidebarProps) {
  const toggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  };

  return (
    <div 
      className={`border-r bg-muted/10 transition-all duration-300 ease-in-out ${
        sidebarExpanded ? 'w-52' : 'w-16'
      }`}
    >
      <div className="p-2 flex flex-col h-[100vh]">
        <div className="flex-1 flex flex-col">
          <RoleFilter 
            selectedRole={selectedRole} 
            setSelectedRole={setSelectedRole} 
            sidebarExpanded={sidebarExpanded} 
          />

          <div className="h-4" />
          
          
          <SprintSelector 
            selectedSprintId={selectedSprintId} 
            setSelectedSprintId={setSelectedSprintId} 
            sidebarExpanded={sidebarExpanded}
            boardId={boardId}
            onCreateSprint={onCreateSprint}
          />
        </div>

        <Button 
          variant="ghost" 
          size="icon" 
          className="self-end mt-4"
          onClick={toggleSidebar}
          title={sidebarExpanded ? "Collapse View" : "Expand View"}
        >
          {sidebarExpanded ? <ChevronLeft /> : <ChevronRight />}
        </Button>
      </div>
    </div>
  );
}
